import ReactGA from 'react-ga4';
export default function GA4EventSend(action: string, event_category: string, event_label: string, value: number, non_interaction: boolean) {
    ReactGA.event({
        action: action,
        value: value,
        category: event_category,
        label: event_label,
        nonInteraction: non_interaction,
    });
}